import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { IneltroCredentialsInputDTORuntype, IneltroResponseBodyDTORuntype } from './ineltroBackendTypes';

export const ineltroEndpoints = {
    'GET /3rdparty/ineltro/credentials': endpoint({
        description: 'Returns credentials for Ineltro integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: IneltroResponseBodyDTORuntype,
    }),
    'POST /3rdparty/ineltro/credentials': endpoint({
        description: 'Uploads credentials for Ineltro API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: IneltroCredentialsInputDTORuntype,
        responseBody: IneltroResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/ineltro/credentials'],
    }),
    'PATCH /3rdparty/ineltro/credentials': endpoint({
        description: 'Updates credentials for Ineltro API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: IneltroCredentialsInputDTORuntype,
        responseBody: IneltroResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/ineltro/credentials'],
    }),
    'DELETE /3rdparty/ineltro/credentials': endpoint({
        description: 'Deletes existing credentials for Ineltro API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/ineltro/credentials'],
    }),
};
